import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import * as styles from './Item.css';

const cx = classNames.bind(styles);

const Item = (props) => {
    const { children, containerClass, containerWidth } = props;
    return (
        <div data-automation-id="block" className={cx(containerClass, containerWidth)}>
            {children}
        </div>
    );
};

Item.propTypes = {
    children: PropTypes.element.isRequired,
    containerWidth: PropTypes.string,
    containerClass: PropTypes.string,
};

Item.defaultProps = {
    children: '',
    containerWidth: '',
    containerClass: '',
};

export default Item;
